import { InfoIcon } from '@cp-shared-15/frontend-ui';
import { ErrorMessage, Fieldset, FormField, Input, Layout } from '@vwfs-bronson/bronson-react';
import { useField } from 'formik';
import React from 'react';
import { CountryCodeSelection } from './country-code-selection/CountryCodeSelection';

export const PhoneInput: React.FC<{
    id?: string;
    testId: string;
    inputName: string;
    selectName: string;
    tooltip?: string;
    tooltipAriaLabel?: string;
    label: string;
    disabled?: boolean;
    autoComplete?: string;
    required?: boolean;
}> = ({
    testId,
    inputName,
    selectName,
    tooltip,
    tooltipAriaLabel,
    children,
    label,
    disabled,
    autoComplete,
    id,
    required,
}) => {
    const [field, meta] = useField(inputName);
    const infoIcon = tooltip ? <InfoIcon labelId={tooltipAriaLabel} text={tooltip} /> : null;

    return (
        <Fieldset.Row>
            <label htmlFor={id} className={'u-mb-xsmall c-form-field__label'}>
                {label}
                {infoIcon}
            </label>
            <Layout className={'o-layout--flush'}>
                <Layout.Item default={'1/3'}>
                    <CountryCodeSelection name={selectName} testId={testId} disabled={true} />
                </Layout.Item>
                <Layout.Item default={'2/3'}>
                    <FormField type="input">
                        <Input
                            id={id}
                            autoComplete={autoComplete}
                            reversed
                            error={!!(meta.touched && meta.error)}
                            success={meta.touched && !meta.error}
                            type={'tel'}
                            testId={`${testId}-input`}
                            aria-describedby={`error-${id}`}
                            inputMode={'tel'}
                            disabled={disabled}
                            required={required}
                            {...field}
                        >
                            {children}
                        </Input>
                    </FormField>
                </Layout.Item>
                <ErrorMessage aria-hidden={!Boolean(meta.touched && meta.error)} role="alert" id={id}>
                    {meta.touched && meta.error ? meta.error : ''}
                </ErrorMessage>
            </Layout>
        </Fieldset.Row>
    );
};
